import Immutable from 'immutable';
import Doyle from '@jianshu/doyle';
import {
  CONTENT_NOT_FOUND,
  MAX_VIDEO_COUNT,
  PN_ITEM_MASK_CLASSNAME,
} from '../constants/variables';
import keyCode from '../constants/keyCode';
import Dante from '../assets/vendors/dante.no.css';

const {
  $,
} = Dante;
export const isDev = process.env.NODE_ENV === 'development';


export const noop = () => {
};

// 按K格式化数字
export const formatNumByK = (num) => {
  if (num < 0) {
    return 0;
  }
  if (num < 100) {
    return num;
  }
  return `${(num / 1000).toFixed(1)}K`;
};

// 用于需要知道每次的API调用状态的saga action，
export const martinDispatch = (dispatch, action) => {
  return new Promise((resolve = noop, reject = noop) => {
    dispatch({
      ...action,
      resolve,
      reject,
    });
  });
};

export const stopEvent = (e) => {
  e.stopPropagation();
  e.preventDefault();
};

export function getWindowSize() {
  const d = document;
  const root = d.documentElement;
  const body = d.body; // eslint-disable-line prefer-destructuring
  const winW = window.innerWidth || root.clientWidth || body.clientWidth;
  const winH = window.innerHeight || root.clientHeight || body.clientHeight;
  return [winW, winH];
}

export function checkNotes(props) {
  const {
    notebooks,
    match,
  } = props;
  const {
    params: {
      nbId,
    },
  } = match;
  const notes = notebooks.getIn(['entities', nbId, 'notes']);
  return notes && notes.size > 0;
}

export const checkNoteIsInSeq = (props) => {
  const {
    notebooks,
    match,
  } = props;
  const {
    params: {
      nbId,
      noteId,
    },
  } = match;
  const notesSeq = notebooks.getIn(['entities', nbId, 'notes'], Immutable.fromJS([]));
  return notesSeq.includes(+noteId);
};

export function checkContent(props) {
  const {
    content,
    match,
  } = props;
  const {
    params: {
      noteId,
    },
  } = match;
  return content.getIn(['entities', noteId, 'content'], CONTENT_NOT_FOUND) !== CONTENT_NOT_FOUND;
}

export function keyDownResult(e) {
  return {
    esc: e.keyCode === keyCode.ESC,
    save: e.keyCode === 83 && (e.ctrlKey || e.metaKey),
  };
}

// /([\w\s]*)([^\w;x,\-.`'"{}\[\]+_)）（(*&\^@%$#!~\/?]*)/im
// const chineseSymbol = ['，', '。', '！', '？', '：', '；', '、', '《', '》'];
const chineseSymbolRegex = /[^\w\s;,\-.`'"{}[\]+_)）（(*&^@%$#!~/?]/;

// 计算单词个数
export const countWords = (text) => {
  const words = text.replace(/[^\w]/g, ' ').match(/\S+/g);
  return (words !== null ? words.length : 0);
};

// 计算中文个数
export const countChinese = (text) => {
  let total = 0;
  for (let i = 0; i < text.length; i++) {
    const c = text.charAt(i);
    if (c.match(/[\u4e00-\u9fa5]/) || chineseSymbolRegex.test(c)) {
      total++;
    }
  }
  return total;
};

/**
 * 通过文章内容计算摘要和字数
 * @param text {String}
 * @param isMarkdown {Boolean}
 * @return {{abbr:String, wordNum:Number}}
 */
export function calcAbbr(text, isMarkdown = false) {
  if (isMarkdown) {
    const doyle = new Doyle();
    const htmlString = doyle.parse(text);
    let div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = htmlString;
    text = div.textContent; // eslint-disable-line no-param-reassign
    div = null;
  }
  return {
    abbr: text.slice(0, 61),
    wordNum: countWords(text) + countChinese(text),
  };
}

function videoMaker({
                      url,
                      width = 400,
                      height = 400,
                      provider,
                      flash = '',
                    }) {
  const httpReg = /^http:/;
  const { protocol } = window.location;
  url = url.replace(/http:|https:/, ''); // eslint-disable-line
  flash = flash.trim().replace(httpReg, protocol); // eslint-disable-line
  let player = '';
  if (provider === 'bilibili') {
    player = '<div class="video-player player">';
    player += `<video width="${width}" height="${height}" preload="auto" controls="true">`;
    player += `<source src="${url}" type="video/mp4">`;
    player += `<object type="application/x-shockwave-flash" data="${protocol}//static.hdslb.com/play.swf" class="flash" style="width:${width}px; height:${height}px;">`;
    player += '<param name="bgcolor" value="#ffffff">';
    player += '<param name="allowfullscreeninteractive" value="true">';
    player += '<param name="allowfullscreen" value="true">';
    player += '<param name="quality" value="high">';
    player += '<param name="allowscriptaccess" value="always">';
    player += '<param name="wmode" value="direct">';
    player += `<param name="flashvars" value="${flash}">`;
    player += '</object>';
    player += '</video>';
    player += '</div>';
  } else {
    player = `<iframe class="player" src="${url}" height="${height}" width="${width}" frameborder=0 allowfullscreen style="width:${width}px; height:${height}px;"></iframe>`;
  }

  return $(player);
}

function getVideoCoverImage(uuid, dimension) {
  if (dimension) {
    return `${process.env.QINIU_HOST}/videos/cover_imgs/${uuid}?imageView2/1/w/${dimension}/h/${dimension}`;
  }
  return `${process.env.QINIU_HOST}/videos/cover_imgs/${uuid}`;
}

// vedio元素显示的时候需要自己构造dom，这部分dom没有保存
export function formatTheVideoPackage(dom) {
  [].map.call(dom.querySelectorAll('div.video-package'), (v, index) => {
    const elem = $(v);
    if (index > MAX_VIDEO_COUNT) {
      elem.remove();
      return;
    }
    // 已经fixed
    if (elem.find('.video-cover').length) {
      return;
    }
    const width = Math.round(v.offsetWidth);
    const height = Math.round((width / 6) * 5);
    const url = elem.attr('data-video-url');
    const provider = elem.attr('data-provider');
    const flash = elem.attr('data-flash-url');
    const videoPlayer = videoMaker({
      url,
      width,
      height,
      provider,
      flash,
    });
    const caption = elem.find('.video-description');
    const uuid = elem.attr('data-cover-uuid');
    const placeholder = $(`<div class="video-placeholder-area">${caption.html()}</div>`);
    const videoCover = $(`<img class="video-cover" src=${getVideoCoverImage(uuid, 90)}>`);
    placeholder.append(videoCover);
    elem.prepend(placeholder);
    const closeBtn = $('<div class="video-close-button"><i class="fa fa-eject"></i> 收起视频</div>');
    closeBtn.hide();
    elem.append(closeBtn);
    caption.remove(); // 不需要显示标题
    let show = false; // 是否显示了player
    placeholder.on('click', () => {
      if (show) {
        return;
      }
      show = true;
      placeholder.after(videoPlayer);
      placeholder.hide();
      elem.css('margin-bottom', '50px');
      closeBtn.show();
    });
    closeBtn.on('click', () => {
      if (!show) {
        return;
      }
      show = false;
      videoPlayer.remove();
      placeholder.show();
      elem.css('margin-bottom', 'auto');
      closeBtn.hide();
    });
  });
}

export function captureException(e, extra) {
  const {
    Raven,
  } = window;
  if (Raven) {
    Raven.captureException(e, {
      extra,
    });
  }
}

// 获取html的children个数
export function getChildrenNum(html = '') {
  const vDom = $('<div>').html(html);
  return vDom.children().length;
}

function getPNItemMask(index, isActive, isNoMask) {
  const maskElem = $('<span></span>').addClass(PN_ITEM_MASK_CLASSNAME).data('index', index);
  if (isActive) {
    maskElem.addClass('active');
  }
  if (isNoMask) {
    maskElem.addClass('no-mask');
  }
  maskElem.append($('<em>'));
  return maskElem;
}

// 初始化付费文章设置页的html（含mask）
export function formatPNHtml(html) {
  const vDom = $('<div>').html(html);
  const initIndex = 0; // 文章初始时的分割线位置
  const children = vDom.children();
  // 查找初始位置
  // children.forEach((child, index) => {
  //   const childElem = $(child);
  //   const tag = childElem.getNodeName();
  //   if (tag === 'PAY-DIVIDE') {
  //     initIndex = index;
  //   }
  // });
  children.forEach((child, index) => {
    const childElem = $(child);
    const tag = childElem.getNodeName();
    if (['HR', 'PAY-DIVIDE'].indexOf(tag) > -1) {
      return;
    }
    childElem.append(getPNItemMask(index, initIndex === index, index <= initIndex));
  });
  return [vDom.html(), initIndex];
}

export function cleanPNHtml(html, index) {
  const vDom = $('<div>').html(html);
  vDom.find('pay-divide').forEach((item) => {
    $(item).remove();
  });
  vDom.contents().get(index).after($('<pay-divide>'));
  // vDom.children().get(index).after($('<pay-divide>'));
  return vDom.html();
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href; // eslint-disable-line no-param-reassign
  name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line no-useless-escape, no-param-reassign
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// 后端保存富文本时不知道为啥会多出一些换行符
export function cleanTheNoteHtml(html = '') {
  return html.replace(/\n|\r\n/g, '');
}
export const getCookieByName = (name, cookie = document.cookie) => {
  const target = cookie.split(';')
    .map(item => ({ key: item.split('=')[0].trim(), value: item.split('=')[1].trim() }))
    .filter(item => item.key === name)[0];
    return (target && target.value) || '{}';
};



// WEBPACK FOOTER //
// ./src/utils/util.js